import React from 'react'
import {
  AnchorSection,
  IProps as IAnchorSectionProps,
} from 'marketing-site/src/library/elements/AnchorSection'
import { IAnchorSection as IContentfulAnchorSection } from 'marketing-site/@types/generated/contentful'

export const ContentfulAnchorSection = (anchorSection: IContentfulAnchorSection) => (
  <AnchorSection {...transformAnchorSection(anchorSection)} />
)

function transformAnchorSection({ fields }: IContentfulAnchorSection): IAnchorSectionProps {
  return {
    ...fields,
    anchorType: fields.anchorType.replace(/\s+/g, '-').toLowerCase(),
  }
}
